export class Radius {

  constructor(
    public maxDistance: number,
  ) { 
  }
  
}